import React, { useState, useEffect } from 'react'
import { Form, Input, Panel, Message } from 'rsuite'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'

type CustomBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function CustomBlock ({
  block,
  onChange
}: CustomBlockProps) {
  const [ subtypeValue, setSubtypeValue ] = useState(block.subtype || '')
  const [ payloadValue, setPayloadValue ] = useState(() => {
    try {
      return block.payload ? JSON.stringify(block.payload, null, 2) : '{}'
    }
    catch {
      return '{}'
    }
  })
  const [ jsonError, setJsonError ] = useState<string | null>(null)

  useEffect(() => {
    setSubtypeValue(block.subtype || '')
    try {
      setPayloadValue(block.payload ? JSON.stringify(block.payload, null, 2) : '{}')
      setJsonError(null)
    }
    catch {
      setPayloadValue('{}')
    }
  }, [ block.subtype, block.payload ])

  const handleSubtypeChange = (value: string) => {
    setSubtypeValue(value)
    onChange({
      ...block,
      subtype: value || undefined
    })
  }

  const handlePayloadChange = (value: string) => {
    setPayloadValue(value)
    
    try {
      const parsed = JSON.parse(value)
      setJsonError(null)
      onChange({
        ...block,
        payload: parsed
      })
    }
    catch (error) {
      setJsonError((error as Error).message)
    }
  }

  return (
    <div>
      <h4>Кастомный блок</h4>
      <p style={{ fontSize: '12px', color: '#666', marginBottom: 12 }}>
        Универсальный блок для клиент-специфичных компонентов (например, daysWithGulliver, specialPromo и т.д.)
      </p>
      
      <Form fluid>
        <Form.Group controlId="subtype">
          <Form.ControlLabel>ID блока (subtype)</Form.ControlLabel>
          <Input
            value={subtypeValue}
            onChange={handleSubtypeChange}
            placeholder="Например: daysWithGulliver, specialPromo"
          />
          <Form.HelpText>Уникальный идентификатор кастомного блока</Form.HelpText>
        </Form.Group>

        <Form.Group controlId="payload">
          <Form.ControlLabel>Настройки (JSON)</Form.ControlLabel>
          <Input
            as="textarea"
            rows={8}
            value={payloadValue}
            onChange={handlePayloadChange}
            placeholder='{&#10;  "key": "value"&#10;}'
            style={{ fontFamily: 'monospace', fontSize: '13px' }}
          />
          <Form.HelpText>Дополнительные параметры блока в формате JSON</Form.HelpText>
        </Form.Group>
      </Form>

      {jsonError && (
        <Message showIcon type="error" style={{ marginTop: 8 }}>
          <strong>Ошибка JSON:</strong> {jsonError}
        </Message>
      )}
    </div>
  )
}
